export class RegisterInOut {
    get id() {
        return this.registerInOutState.id;
    }
    get inRegisterNumber() {
        return this.registerInOutState.inRegisterNumber;
    }
    get inDate() {
        return this.registerInOutState.inDate;
    }
    get origin() {
        return this.registerInOutState.origin;
    }
    get request() {
        return this.registerInOutState.request;
    }
    get outRegisterNumber() {
        return this.registerInOutState.outRegisterNumber;
    }
    get outDate() {
        return this.registerInOutState.outDate;
    }
    get destination() {
        return this.registerInOutState.destination;
    }
    get agentId() {
        return this.registerInOutState.agentId;
    }
    get report() {
        return this.registerInOutState.report;
    }
    get thirdId() {
        return this.registerInOutState.thirdId;
    }
    get content() {
        return this.registerInOutState.content;
    }
    get contentInfo() {
        return this.registerInOutState.contentInfo;
    }
    get userId() {
        return this.registerInOutState.userId;
    }
    get outPutLock() {
        return this.registerInOutState.outPutLock;
    }
    get fileNumber() {
        return this.registerInOutState.fileNumber;
    }
    set id(id) {
        this.registerInOutState.id = id;
    }
    set inRegisterNumber(inRegisterNumber) {
        this.registerInOutState.inRegisterNumber = inRegisterNumber;
    }
    set inDate(inDate) {
        this.registerInOutState.inDate = inDate;
    }
    set origin(origin) {
        this.registerInOutState.origin = origin;
    }
    set request(request) {
        this.registerInOutState.request = request;
    }
    set outRegisterNumber(outRegisterNumber) {
        this.registerInOutState.outRegisterNumber = outRegisterNumber;
    }
    set outDate(outDate) {
        this.registerInOutState.outDate = outDate;
    }
    set destination(destination) {
        this.registerInOutState.destination = destination;
    }
    set agentId(agentId) {
        this.registerInOutState.agentId = agentId;
    }
    set report(report) {
        this.registerInOutState.report = report;
    }
    set thirdId(thirdId) {
        this.registerInOutState.thirdId = thirdId;
    }
    set content(content) {
        this.registerInOutState.content = content;
    }
    set contentInfo(contentInfo) {
        this.registerInOutState.contentInfo = contentInfo;
    }
    set userId(userId) {
        this.registerInOutState.userId = userId;
    }
    set outPutLock(outPutLock) {
        this.registerInOutState.outPutLock = outPutLock;
    }
    set fileNumber(fileNumber) {
        this.registerInOutState.fileNumber = fileNumber;
    }
    constructor(registerInOutState) {
        this.registerInOutState = registerInOutState;
    }
    getState() {
        return this.registerInOutState;
    }
}
